import { IconProps } from "../../utils/global-types/global-types";

const UseCaseIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-6 h-6"}
    {...rest}
  >
    <g clipPath="url(#clip0_10284_118618)">
      <path
        fill="currentColor"
        d="M10.3333 1.83333H7.66667C7.02233 1.83333 6.5 2.35567 6.5 3V5.66667C6.5 6.311 7.02233 6.83333 7.66667 6.83333H10.3333C10.9777 6.83333 11.5 6.311 11.5 5.66667V3C11.5 2.35567 10.9777 1.83333 10.3333 1.83333Z"
      />
      <path
        fill="currentColor"
        d="M5.66634 11.1667H2.99967C2.35534 11.1667 1.83301 11.689 1.83301 12.3333V15C1.83301 15.6443 2.35534 16.1667 2.99967 16.1667H5.66634C6.31067 16.1667 6.83301 15.6443 6.83301 15V12.3333C6.83301 11.689 6.31067 11.1667 5.66634 11.1667Z"
      />
      <path
        fill="currentColor"
        d="M15.0003 11.1667H12.3337C11.6893 11.1667 11.167 11.689 11.167 12.3333V15C11.167 15.6443 11.6893 16.1667 12.3337 16.1667H15.0003C15.6447 16.1667 16.167 15.6443 16.167 15V12.3333C16.167 11.689 15.6447 11.1667 15.0003 11.1667Z"
      />
      <path
        fill="currentColor"
        d="M13.6663 10.8333C13.5337 10.8333 13.4066 10.7807 13.3128 10.6869C13.219 10.5931 13.1663 10.4659 13.1663 10.3333V9.66667C13.1663 9.62246 13.1488 9.58007 13.1175 9.54882C13.0863 9.51756 13.0439 9.5 12.9997 9.5H4.99967C4.95547 9.5 4.91308 9.51756 4.88182 9.54882C4.85057 9.58007 4.83301 9.62246 4.83301 9.66667V10.3333C4.83301 10.4659 4.78033 10.5931 4.68656 10.6869C4.59279 10.7807 4.46562 10.8333 4.33301 10.8333C4.2004 10.8333 4.07322 10.7807 3.97945 10.6869C3.88569 10.5931 3.83301 10.4659 3.83301 10.3333V9.66667C3.83336 9.35736 3.95639 9.06081 4.17511 8.8421C4.39382 8.62338 4.69036 8.50035 4.99967 8.5H12.9997C13.309 8.50035 13.6055 8.62338 13.8242 8.8421C14.043 9.06081 14.166 9.35736 14.1663 9.66667V10.3333C14.1663 10.4659 14.1137 10.5931 14.0199 10.6869C13.9261 10.7807 13.7989 10.8333 13.6663 10.8333Z"
      />
      <path
        fill="currentColor"
        d="M9 9.5C8.86739 9.5 8.74022 9.44732 8.64645 9.35355C8.55268 9.25979 8.5 9.13261 8.5 9V6.33333C8.5 6.20073 8.55268 6.07355 8.64645 5.97978C8.74022 5.88601 8.86739 5.83333 9 5.83333C9.13261 5.83333 9.25978 5.88601 9.35355 5.97978C9.44732 6.07355 9.5 6.20073 9.5 6.33333V9C9.5 9.13261 9.44732 9.25979 9.35355 9.35355C9.25978 9.44732 9.13261 9.5 9 9.5Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_10284_118618">
        <rect width="16" height="16" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

export default UseCaseIcon;
